import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { PhosphorIconComponent } from '@cintra-payroll-hr/components';

@Component({
  selector: 'app-select-cell-renderer',
  imports: [PhosphorIconComponent],
  template: `
    @if (editable()) {
      <span class="select-trigger">
        <span class="ci-text-md" [class.select-placeholder]="!hasValue()">{{ displayValue() }}</span>
        <ci-phosphor-icon name="caret-down" size="lg" variant="primary" class="select-caret" aria-hidden="true" />
      </span>
    } @else {
      <span>{{ displayValue() }}</span>
    }
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
      }

      .select-trigger {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      .select-placeholder {
        color: var(--colors-text-quaternary);
      }

      .select-caret {
        flex-shrink: 0;
        margin-left: var(--spacing-md);
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SelectCellRendererComponent implements ICellRendererAngularComp {
  readonly displayValue = signal('');
  readonly editable = signal(false);
  readonly hasValue = signal(false);

  agInit(params: ICellRendererParams): void {
    this.update(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.update(params);
    return true;
  }

  private update(params: ICellRendererParams): void {
    const editableDef = params.colDef?.editable;
    this.editable.set(typeof editableDef === 'function' ? editableDef(params as any) : editableDef === true);
    this.hasValue.set(params.value != null);
    this.displayValue.set(params.valueFormatted ?? params.value ?? '');
  }
}
